import Marquee from "react-fast-marquee";
import { Cpu, ShieldCheck, Activity, Stethoscope, MessageCircle } from "lucide-react";

const ITEMS = [
  { icon: Cpu, label: "Tecnologia TytoCare", color: "#5B2C91" },
  { icon: ShieldCheck, label: "Professionisti sanitari qualificati", color: "#10B981" },
  { icon: Activity, label: "Esame assistito in diretta", color: "#FF8A5B" },
  { icon: Stethoscope, label: "Medici generalisti e specialisti", color: "#3B82F6" },
  { icon: MessageCircle, label: "Richiesta semplice tramite WhatsApp", color: "#FF7EB3" },
];

function Pill({ item }) {
  const Icon = item.icon;
  return (
    <div className="mx-3 flex items-center gap-3 rounded-full bg-white px-5 py-3 shadow-[0_8px_30px_rgb(91,44,145,0.06)] ring-1 ring-[#5B2C91]/5">
      <span
        className="inline-flex h-8 w-8 items-center justify-center rounded-full"
        style={{ backgroundColor: `${item.color}1A`, color: item.color }}
      >
        <Icon className="h-4 w-4" />
      </span>
      <span className="whitespace-nowrap text-sm font-semibold text-[#1F152E]">{item.label}</span>
    </div>
  );
}

export default function TrustStrip() {
  return (
    <section id="trust" className="bg-[#F6F4FA] py-6 sm:py-8" data-testid="trust-strip">
      {/* Desktop / tablet: slow editorial marquee */}
      <div className="hidden md:block">
        <Marquee speed={38} gradient gradientColor="#F6F4FA" gradientWidth={80} pauseOnHover>
          {ITEMS.map((item) => (
            <Pill key={item.label} item={item} />
          ))}
        </Marquee>
      </div>

      {/* Mobile: compact 2-column grid */}
      <div className="md:hidden grid grid-cols-2 gap-3 px-4">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.label}
              className="flex flex-col gap-2 rounded-2xl bg-white p-3.5 shadow-[0_8px_30px_rgb(91,44,145,0.06)]"
              data-testid="trust-strip-item"
            >
              <span
                className="inline-flex h-8 w-8 items-center justify-center rounded-full"
                style={{ backgroundColor: `${item.color}1A`, color: item.color }}
              >
                <Icon className="h-4 w-4" />
              </span>
              <span className="text-xs font-semibold leading-snug text-[#1F152E]">{item.label}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
